import React, { forwardRef } from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import PauseIcon from "@material-ui/icons/Pause";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import FastForwardIcon from "@material-ui/icons/FastForward";
import FastRewindIcon from "@material-ui/icons/FastRewind";
import HomeIcon from "@material-ui/icons/Home";
import clsx from "clsx";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
// import HorizontalScroll from "react-scroll-horizontal";
// import TextAnimation from "react-animate-text";
// import UseAnimations from "react-useanimations";
// import FullscreenIcon from '@material-ui/icons/Fullscreen';

const useStyles = makeStyles((theme) => ({
  controlsWrapper: {
    // width: 960,
    // height: 540,
    // border: "1px solid #c6c6c6",
    // position: "relative",
  },
  controlsWrapperRef: {
    visibility: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    background: "linear-gradient(rgba(63, 63, 64, 0),#3f3f40)",
    zIndex: 1,
    // border: "1px solid #c6c6c6",
    // background: "linear-gradient(rgba(63, 63, 64, 0),#3f3f40)",
    [theme.breakpoints.down("md")]: {
      visibility: "visible",
    },
  },
  controlIcons: {
    color: "#fff",
    fontSize: 50,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#fff",
      transform: "scale(1)",
    },
  },
  bottomIcons: {
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  },
  bottomIcons2: {
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  },
  bottomIcons3: {
    padding: "6px",
    background: "rgba(0, 0, 0, 0.87)",
    marginRight: "12px",
    color: "white",
    "&:hover": {
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
  volumeSlider: {
    width: 76,
    marginLeft: 6,
    marginRight: 6,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  pageNation: {
    width: 150,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#999",
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    // paddingLeft: 16,
    // paddingRight: 16,
    padding: "8px 8px",
    marginBottom: 16,
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    width: 30,
  },
  headerTitle: {
    flex: 1,
  },
  full: {
    cursor: "pointer",
    width: 70,
  },
  title2: {
    paddingLeft: 16,
    paddingRight: 16,
    color: "white",
  },
  controlsPop: {
    padding: 12,
  },
  list: {
    color: "white",
    padding: "90px 65px",
    flexDirection: "inherit",
    "& >div": {
      width: "398px",
      height: 50,
      display: "flex",
      alignItems: "center",
      fontSize: 18,
      cursor: "pointer",
      "&:hover": {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
  },
  topOff: {
    display: "none",
  },
  time: {
    color: "white",
    width: 120,
    marginLeft: 12,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      marginLeft: 0,
    },
  },
  playListView: {
    height: 170,
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "scroll",
    overflowY: "hidden",
    maxWidth: 1920,
    "&  .playlistitem": {
      width: 240,
      height: 136,
      borderRadius: 6,
      flex: "0 0 auto",
      marginLeft: 28,
      background: "#fff",
      backgroundSize: "240px 136px",
      cursor: "pointer",
    },
    // marginBottom: 24,
  },
  timeView: {
    width: 50,
    height: 20,
    background: "#3f3f40",
    marginTop: 10,
    marginRight: 12,
    borderRadius: 12,
    textAlign: "center",
    color: "#fff",
    fontSize: 12,
    lineHeight: 1.7,
  },
  scrollRef: {
    height: 170,
    position: "absolute",
  },
  leftMenu: {
    background: "rgb(97 97 97 / 90%)",
    left: 0,
    margin: 0,
    position: "absolute",
    zIndex: 2,
    cursor: "pointer",
  },
  rightMenu: {
    background: "rgb(97 97 97 / 90%)",
    right: 0,
    margin: 0,
    position: "absolute",
    zIndex: 2,
    cursor: "pointer",
  },
  button: {
    zIndex: 10,
  },
  next: {
    width: 180,
    height: 60,
    marginTop: 16,
    marginRight: 16,
    background: "#5d2cff",
    fontWeight: 600,
  },
  headerButton: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const PrettoSlider = withStyles({
  root: {
    color: "#88daff",
    padding: "6px 0 6px 0",
  },
  thumb: {
    height: 0,
    width: 0,
    backgroundColor: "#fff",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 4,
  },
  rail: {
    height: 4,
  },
})(Slider);

const PrettoVolumSlider = withStyles({
  root: {
    color: "#fff",
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: "#fff",
    // border: "1px solid currentColor",
    marginTop: -4,
    marginLeft: -8,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider);

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

const PlayerControls = forwardRef(
  (
    {
      onPlayPause,
      onRewind,
      onFastForward,
      onMuted,
      playing,
      muted,
      volume,
      playbackRate,
      onVolumechange,
      onVolumeSeekDown,
      onPlaybackRateChange,
      onToggleFullScreen,
      played,
      onSeek,
      onSeekMouseDown,
      onSeekMouseUp,
      elapsedTime,
      totalDuration,
      onBookmark,
      onMoviePlus,
      onMovieTrackDown,
      nCount,
      leng,
      title,
      cancerData,
      onTrackGo,
      onGoHome,
      visible,
    },
    ref
  ) => {
    const classes = useStyles();
    // const slideRef = useRef(null);
    // const [sOpen, setSopen] = useState(false);
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open = Boolean(anchorEl);
    // const id = open ? "playbackrate-popover" : undefined;
    // const handleonTrackGo = (e, idex) => {
    //   e.stopPropagation();
    //   onTrackGo(idex);
    // };
    // const handleonTrackLastGo = (idex) => {
    //   onTrackGo(idex);
    // };
    const handleTest = (e) => {
      e.stopPropagation();
    };
    // const handleLeft = () => {
    //   window.addEventListener("scroll", () => {
    //     const value = window.scrollY;
    //     slideRef.current.style.left = 100 + "px";
    //   });
    //   // let slideRefWidth = slideRef.current.offsetWidth;
    // };
    return (
      <>
        {/* <SlidePop open={sOpen}>
          <div className={classes.controlsPop}>
            <Grid container alignItems="center">
              <IconButton className={classes.bottomIcons2} onClick={onOpen}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Typography variant="h6" className={classes.title2}>
                {cancerData.name} 조기검진
              </Typography>
            </Grid>
            <Grid container direction="column" className={classes.list}>
              {cancerData.scenario.map((data, i) => (
                <Grid key={i} onClick={(e) => handleonTrackGo(e, i)}>
                  {i + 1}.&nbsp; {data.title}
                </Grid>
              ))}
            </Grid>
          </div>
        </SlidePop> */}
        <div className={classes.controlsWrapper}>
          <div className={classes.controlsWrapperRef} ref={ref}>
            {/** top Control */}
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="flex-end"
              className={classes.headerButton}
              style={{ padding: 16 }}
              // className={classes.topOff : null}
            >
              {/* <Grid item> */}
              {/* <Grid
                container
                direction="row"
                alignItems="center"
                className={classes.headerTitle}
                onClick={(e) => onToggleFullScreen(e)}
              >
                <Typography variant="h6">ddd</Typography>
              </Grid> */}
              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-around"
                className={classes.full}
              >
                <Typography
                  variant="h6"
                  className={classes.title}
                  onClick={(e) => onGoHome(e)}
                >
                  <HomeIcon />
                </Typography>
                {/* <Typography
                  variant="h6"
                  className={classes.title}
                  onClick={(e) => onToggleFullScreen(e)}
                >
                  <FullscreenIcon />
                </Typography> */}
              </Grid>
            </Grid>
            {/* <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CheckCircleOutlineRoundedIcon />}
                onClick={() =>
                  handleonTrackLastGo(cancerData.scenario.length - 1)
                }
                // onClick={onBookmark}
              >
                검진을 받을지 결정하기
              </Button>
            </Grid> */}
            {/* </Grid> */}
            {/** middle Controls */}
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              {/* <IconButton
                className={classes.controlIcons}
                aria-label="require"
                onClick={onPlayPause}
              >
                {playing ? (
                  <PauseIcon fontSize="inherit" style={{ fontSize: 72 }} />
                ) : (
                  <PlayArrowIcon fontSize="inherit" style={{ fontSize: 72 }} />
                )}
              </IconButton> */}
            </Grid>
            {/** bottom Controls */}
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="space-between"
              onClick={handleTest}
              style={{
                padding: "0px 0px 1px 0px",
                // background: "rgb(0 0 0 / 87%)",
              }}
            >
              <Grid item xs={12}>
                {/* <Grid
                  container
                  alignItems="center"
                  className={classes.playListView}
                  ref={slideRef}
                > */}
                {/* <HorizontalScroll pageLock={true}>
                    {cancerData.scenario.map((data, i) => (
                      <Grid
                        container
                        className="playlistitem"
                        justify="flex-end"
                        key={i}
                        onClick={(e) => handleonTrackGo(e, i)}
                        style={{
                          backgroundImage: `url( "/images/${cancerData.enName}/${cancerData.enName}_${i}.png" )`,
                          border:
                            nCount === i
                              ? "2px solid #115bab"
                              : "2px solid rgb(17 91 171 / 16%)",
                        }}
                      >
                        <div className={classes.timeView}>{data.running}</div>
                      </Grid>
                    ))}
                    <Grid
                      container
                      className="playlistitem"
                      justify="flex-end"
                      key="1232314kfkf"
                      style={{ background: "none", cursor: "auto" }}
                    ></Grid>
                    <Grid
                      container
                      className="playlistitem"
                      justify="flex-end"
                      key="1232314kf2kf"
                      style={{ background: "none", cursor: "auto" }}
                    ></Grid>
                    <Grid
                      container
                      className="playlistitem"
                      justify="flex-end"
                      key="1232314kf211kf"
                      style={{ background: "none", cursor: "auto" }}
                    ></Grid>
                  </HorizontalScroll> */}

                {/* <div className={classes.leftMenu} onClick={handleLeft}>
                    <IconButton
                      aria-label="delete"
                      disabled
                      color="primary"
                      className={classes.button}
                    >
                      <ArrowBackIcon style={{ color: "#fff" }} />
                    </IconButton>
                  </div>
                  <div className={classes.rightMenu}>
                    <IconButton
                      aria-label="delete"
                      disabled
                      color="primary"
                      className={classes.button}
                    >
                      <ArrowForwardIcon style={{ color: "#fff" }} />
                    </IconButton>
                  </div> */}
                {/* </Grid> */}
              </Grid>
              <Grid item xs={12}>
                <PrettoSlider
                  min={0}
                  max={100}
                  value={played * 100}
                  onChange={onSeek}
                  onMouseDown={onSeekMouseDown}
                  onChangeCommitted={onSeekMouseUp}
                  ValueLabelComponent={(props) => (
                    <ValueLabelComponent {...props} open={props?.open && visible} value={elapsedTime} />
                  )}
                />
              </Grid>
              <Grid item>
                <Grid container alignItems="center" direction="row">
                  <IconButton
                    className={classes.bottomIcons}
                    onClick={onPlayPause}
                  >
                    {playing ? (
                      <PauseIcon style={{ fontSize: 24 }} />
                    ) : (
                      <PlayArrowIcon style={{ fontSize: 24 }} />
                    )}
                  </IconButton>
                  <Grid className={classes.time}>
                    {elapsedTime} / {totalDuration}
                  </Grid>
                  <IconButton
                    onClick={onMovieTrackDown}
                    className={classes.bottomIcons}
                  >
                    <FastRewindIcon style={{ fontSize: 24 }} />
                  </IconButton>
                  {/* <Grid style={{ width: 60, color: "#fff" }}>
                  {nCount + 1 < 10 ? "0" + (nCount + 1) : nCount + 1} /{" "}
                  {leng < 10 ? "0" + leng : leng}
                </Grid> */}
                  <IconButton
                    onClick={onMoviePlus}
                    className={classes.bottomIcons}
                  >
                    <FastForwardIcon style={{ fontSize: 24 }} />
                  </IconButton>
                  {/* <IconButton className={classes.bottomIcons} onClick={onRewind}>
                  <Replay10Icon fontSize="small" />
                </IconButton> */}
                  {/* <IconButton
                  className={classes.bottomIcons}
                  onClick={onFastForward}
                >
                  <Forward10Icon fontSize="small" />
                </IconButton> */}

                  {/* <Slider
                  min={0}
                  max={100}
                  value={volume * 100}
                  className={classes.volumeSlider}
                  onChange={onVolumechange}
                  onChangeCommitted={onVolumeSeekDown}
                /> */}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container alignItems="center" direction="row">
                  {/* <Button
                  variant="text"
                  onClick={handlePopover}
                  className={classes.bottomIcons}
                >
                  <div>{playbackRate} 배</div>
                </Button>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                >
                  <Grid container direction="column-reverse">
                    {[0.5, 1, 1.5, 2].map((rate) => (
                      <Button
                        variant="text"
                        key={rate}
                        onClick={() => handleRate(rate)}
                      >
                        <Typography
                          color={
                            rate === playbackRate ? "secondary" : "initial"
                          }
                        >
                          {rate} 배
                        </Typography>
                      </Button>
                    ))}
                  </Grid>
                </Popover> */}
                  <IconButton
                    className={clsx(classes.bottomIcons, classes.small)}
                    onClick={onMuted}
                  >
                    {muted ? (
                      <VolumeOffIcon style={{ fontSize: 24 }} />
                    ) : (
                      <VolumeUpIcon style={{ fontSize: 24 }} />
                    )}
                  </IconButton>
                  <PrettoVolumSlider
                    min={0}
                    max={100}
                    value={volume * 100}
                    className={classes.volumeSlider}
                    onChange={onVolumechange}
                    onChangeCommitted={onVolumeSeekDown}
                  />
                  <IconButton
                    onClick={(e) => onToggleFullScreen(e)}
                    className={classes.bottomIcons}
                  >
                    <FullscreenIcon style={{ fontSize: 24 }} />
                  </IconButton>
                  {/* <Grid
                  container
                  direction="row"
                  justify="center"
                  className={classes.pageNation}
                ></Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </>
    );
  }
);

export default PlayerControls;
